import type { PreparedLocationHit, LocationHit } from '../types'
import { geoDistance } from './geoDistance'

export function prepareItems(
  items: LocationHit[],
  geoLocation: { lat: number; lng: number }
): PreparedLocationHit[] {
  return items.map((item) => {
    // currently needed because of inconsistent data:
    const newGeoLocation = {
      lat: item._geoloc?.lat,
      lng: item._geoloc
        ? 'lng' in item._geoloc
          ? item._geoloc.lng
          : item._geoloc?.lon
        : undefined
    }

    return {
      ...item,
      _geoloc: newGeoLocation,
      distance: geoDistance(geoLocation, newGeoLocation)
    }
  })
}
